import { getFullnodeUrl } from '@iota/iota-sdk/client';

import { Env } from 'modules/common';

const iotaNetworks = {
  dev: 'testnet',
  stage: 'testnet',
  prod: 'mainnet',
};

const DEFULT_FULLNODE_URL = 'https://api.mainnet.iota.cafe';

export function getFullnodeUrlByEnv(env: Env) {
  const url = getFullnodeUrl(iotaNetworks[env]);

  return url || DEFULT_FULLNODE_URL;
}
